/** @jsxImportSource @emotion/react */

import type { VideoToolboxChatStyles } from './videoToolboxChatStyles';
import { DEFAULT_VIDEO_TOOLBOX_CHAT_STYLES } from './videoToolboxChatStyles';
import type { VideoToolboxClipReadStatus } from './videoToolboxClipReadStatusLib';

export type VideoToolboxClipbarProps = {
  readStatus: VideoToolboxClipReadStatus;
  styles?: Pick<VideoToolboxChatStyles, 'clipbar' | 'clipbarStatus'>;
};

/** Pinned read state between the video and the Ask Kai thread. */
export const VideoToolboxClipbar = ({
  readStatus,
  styles = DEFAULT_VIDEO_TOOLBOX_CHAT_STYLES,
}: VideoToolboxClipbarProps) => (
  <div css={styles.clipbar} className={'po-clipbar'} data-testid={'video-toolbox-clipbar'}>
    <span css={styles.clipbarStatus} className={'po-clipbar-s'} data-testid={'video-toolbox-clipbar-status'}>
      {readStatus}
    </span>
  </div>
);
